import {
  isValidUrl,
  isSmartPageSupportVideo,
} from '@bingads-webui-campaign-react/smart-component-util';
import { dataProperties, getDataFromConfig, DescriptionHardLimit } from './data-config';

export function getErrors(videoConfig, i18n) {
  const errors = {};
  const { videoUrl, videoCanPlay, videoDescription } = getDataFromConfig(videoConfig);

  if (videoUrl && isValidUrl(videoUrl)) {
    if (isSmartPageSupportVideo(videoUrl)) {
      if (!videoCanPlay) {
        errors[dataProperties.videoUrl] = i18n.getString(_TL_('Invalid video. Please make sure you entered your video URL correctly.'));
      }
    } else {
      errors[dataProperties.videoUrl] = i18n.getString(_TL_('Please provide a valid YouTube or Vimeo URL.'));
    }
  } else if (videoUrl && !isValidUrl(videoUrl)) {
    errors[dataProperties.videoUrl] = i18n.getString(_TL_('Please provide a valid YouTube or Vimeo URL. '));
  } else {
    errors[dataProperties.videoUrl] = i18n.getString(_TL_('Please provide a valid YouTube or Vimeo URL.'));
  }

  if (videoDescription && videoDescription.length > DescriptionHardLimit) {
    errors[dataProperties.videoDescription] = i18n.getString(_TL_('Your video description cannot exceed {{num}} characters.'), { num: DescriptionHardLimit });
  }

  return errors;
}
